import {userConstants} from '../../_constants';

export function deliverySchedulerDateTime(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SCHEDULER_DATE_TIME_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_SCHEDULER_DATE_TIME_SUCCESS:
      /*if(action.data.data) {
        action.data.data.sort(function(a, b){return a.date > b.date_time});
        action.data.data.sort((a, b) => (a.date_time - b.date_time));
      }*/

      return {
        loading: false,
        // typeDelivery: action.data,
        ...action.data,
      };
    case userConstants.GET_SCHEDULER_DATE_TIME_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
